/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { provisionalListConfig } from '../../config/provisionalLists.config';
export interface IProvisionalListPluginMethods extends IPluginMethodMap {
  getProvisionalListSync(args?: any): any;
}

export class ProvisionalListPlugin implements IAgentPlugin {
  readonly methods: IProvisionalListPluginMethods;

  constructor() {
    this.methods = {
      getProvisionalListSync: this.getProvisionalListSync.bind(this),
    };
  }

  async getProvisionalListSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    return {
      ProvisionalList: provisionalListConfig,
    };
  }
}
